<template>
  <div>
    <input
        type="file"
        class="form-control-file"
        accept="image/jpeg,image/jpg,image/png,image/webp"
        @change="onChange"
    />

    <img
        v-if="preview"
        :src="preview"
        class="img-preview mt-2"
        alt="Preview"
    />
  </div>
</template>

<script>
export default {
  name: "ImageUploader",

  props: {
    value: {
      type: [File, String],
      default: null
    }
  },

  data() {
    return {
      preview: null
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(file) {
        if (!file) {
          this.clearPreview()
          return
        }

        if (typeof file === 'string') {
          this.preview = file
        } else if (file instanceof File) {
          this.setPreview(file)
        }
      }
    }
  },

  methods: {
    onChange(e) {
      const file = e.target.files?.[0]
      if (!file) return

      this.setPreview(file)

      // 🔥 inilah v-model-nya
      this.$emit("input", file)
    },

    setPreview(file) {
      this.clearPreview()
      this.preview = URL.createObjectURL(file)
    },

    clearPreview() {
      if (this.preview?.startsWith("blob:")) {
        URL.revokeObjectURL(this.preview)
      }
      this.preview = null
    }
  },

  beforeDestroy() {
    this.clearPreview()
  }
}
</script>

<style scoped>
.img-preview {
  max-width: 500px;
  max-height: 200px;
  object-fit: cover;
}
</style>
